export interface ReservaTgListItem {
  propostaId: number
  contratoId?: string
  codigoTg: string
  nomeEvento: string
  clienteId?: number
  nomeCliente: string
  subClienteId?: number | null
  nomeSubCliente?: string | null
  dataInicio: string
  dataFinal: string
  totalOs: number
  osPendentes: number
}

export class SearchReservaTgModel {
  public codigoTg: string | null = null
  public nomeCliente: string | null = null
  public dataInicio: string | null = null
  public dataFinal: string | null = null
}

export interface AgendaComprasOsListItem {
  cosId: string
  codigoOs: string
  dataInicio: string
  horaInicio: string
  dataFinal: string
  horaFinal: string
  observacaoOs?: string | null
  statusOsId: number
  descricaoStatusOs: string
  statusOsAndamentoId: number
  statusOsAndamento: string
  codigoTg: string
  contratoId?: string
  nomeEvento: string
  quantidadePassageiros: number
  nomeCliente: string
  nomeSubCliente?: string | null
  descricaoOrigem: string
  descricaoDestino: string
  servico: string
  descricaoTipoServico: string
  tipoVeiculoId?: number | null
  descricaoTipoVeiculo?: string | null
  tipoMotoristaId?: number | null
  descricaoTipoMotorista?: string | null
  fornecedorId?: number | null
  nomeFornecedor?: string | null
  statusComprasId: number
  descricaoStatusCompras: string
  valorTotal?: number | null
  valorUnitarioMotorista?: number | null
  valorUnitarioVeiculo?: number | null
  quantidadeVeiculo?: number | null
  quantidadeMotorista?: number | null
  isPendente: 'S' | 'N'
}

export interface CreateComprasOrdemServicoModel {
  ordemServicoId: string
  tipoVeiculoId?: number | null
  tipoMotoristaId?: number | null
  quantidadeVeiculo?: number
  quantidadeMotorista?: number
}

export interface EditComprasOsModel {
  id: string
  fornecedorId: number
  valorUnitarioMotorista: number
  valorUnitarioVeiculo: number
  enviarEmail: boolean
  multiplicadorMargem?: number
  valorCusto?: number
  obsCliente?: string | null
  obsFornecedorOperador?: string | null
}

export interface EditComprasOsLoteModel {
  comprasOsIds: string[]
  fornecedorId: number
  valorUnitarioMotorista: number
  valorUnitarioVeiculo: number
  enviarEmail: boolean
  multiplicadorMargem?: number
  valorCusto?: number
  obsCliente?: string | null
  obsFornecedorOperador?: string | null
}

export interface EditComprasOsLoteResponse {
  sucesso: string[]
  erros: { comprasOsId: string; mensagem: string }[]
}

export interface NotificarComprasOsModel {
  comprasOsIds: string[]
  enviarEmail: boolean
  gerarLinkWhatsApp: boolean
}

export interface NotificarComprasOsResponse {
  emailsEnviados: number
  linksWhatsApp: { nomeFornecedor: string; codigosOs: string[]; link: string }[]
}

export interface LinkAcessoWhatsAppResponse {
  codigoOs: string
  nomeFornecedor: string
  senhaAcesso: string
  linkAcesso: string
  mensagem: string
  linkWhatsApp: string
}

export interface ComprasOrdemServicoVmGeral {
  id: string
  tipoComprasId?: number
  descricaoTipoCompras?: string
  statusCompra?: number
  descricaoStatusCompra?: string
  contratoId?: string
  codigoTg: string
  codigoOs: string
  dataInicio: string
  datafinal: string
  horaInicio: string
  horafinal: string
  fornecedorId?: number | null
  nomeFornecedor?: string | null
  tipoveiculoId?: number | null
  descricaoTipoVeiculo?: string | null
  tipoMotoristaId?: number | null
  descricaoTipoMotorista?: string | null
  quantidadeVeiculo?: number | null
  quantidadeMotorista?: number | null
  valorUnitarioVeiculo?: number | null
  valorUnitarioMotorista?: number | null
  valorTotal?: number | null
  observacaoOs?: string | null
  multiplicadorMargem?: number | null
  valorCusto?: number | null
  target?: number | null
  savings?: number | null
  obsLogistica?: string | null
  obsCliente?: string | null
  obsFornecedorOperador?: string | null
  valorTarifario?: number | null
  prazoPagamento?: number | null
}

export class SearchAgendaComprasOsModel {
  public codigoTg: string | null = null
  public codigoOs: string | null = null
  public nomeCliente: string | null = null
  public dataInicio: string | null = null
  public dataFinal: string | null = null
  public descricaoOrigem: string | null = null
  public descricaoDestino: string | null = null
  public servico: string | null = null
  public descricaoTipoVeiculo: string | null = null
  public descricaoTipoMotorista: string | null = null
  public pendente: boolean | null = null
  public statusComprasId: number | null = null
  public statusOsId: number | null = null
}
